import { AppSettings } from '../../../settings';
import { Component, OnInit, Input } from '@angular/core';
import { CostCenterSummary } from '../state.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-costcenter-transaction-item]',
  templateUrl: './costcenter-transaction-item.component.html',
  styleUrls: ['./costcenter-transaction-item.component.scss']
})
export class CostcenterTransactionItemComponent implements OnInit {
  @Input() summary: CostCenterSummary;
  details = false;
  billDetails = false;

  currencySuffix: string;
  constructor(
    private _settings: AppSettings
  ) {
    this.currencySuffix = _settings.getCurrencySuffix(new Date());
  }

  ngOnInit() {
  }

  toggleDetails(){
    this.details = !this.details;
  }

  toggleBillDetails(){
    this.summary.dispenserBoxBills.sort((a,b) => a.denomination - b.denomination)
    this.billDetails = !this.billDetails;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/admin-state/costcenter-transaction-item/costcenter-transaction-item.component.ts